import gql from 'graphql-tag';

export default function (params) {
    return gql`
    mutation{
        unassignSaltoGateway(
        id: "${params.id}",
        ){
            errors
        }
    }
    `;
}
